import { apiService } from './apiService';

export interface RedisConfigurationDto {
  tenantId?: string;
  name: string;
  connectionString?: string;
  host?: string;
  port?: number;
  database?: number;
  password?: string;
  isActive?: boolean;
  description?: string;
}

export interface RedisConfiguration {
  id: string;
  tenantId: string;
  name: string;
  connectionString?: string;
  host?: string;
  port?: number;
  database?: number;
  password?: string;
  isActive?: boolean;
  description?: string;
  createdAt?: string;
  updatedAt?: string;
  createdBy?: string;
}

export const redisConfigurationService = {
  getList: () =>
    apiService.get('/api/RedisConfiguration/list', {}, 'backend') as Promise<RedisConfiguration[]>,

  getById: (id: string) =>
    apiService.get(`/api/RedisConfiguration/details/${id}`, {}, 'backend') as Promise<RedisConfiguration>,

  create: (dto: RedisConfigurationDto) =>
    apiService.post('/api/RedisConfiguration', dto, 'backend'),

  update: (id: string, dto: RedisConfigurationDto) =>
    apiService.put(`/api/RedisConfiguration/${id}`, dto, 'backend'),

  delete: (id: string) =>
    apiService.delete(`/api/RedisConfiguration/${id}`, 'backend'),
};
